module.exports = __webpack_public_path__ + "img/Jack_Fields.09ab724a.jpg";